
import React from "react";
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { ArrowUpDown } from "lucide-react";

interface NotificationListHeaderProps {
  onSort: (key: string) => void;
  sortConfig?: { key: string; direction: 'asc' | 'desc' };
  showBulkSelect?: boolean;
  isAllSelected?: boolean;
  isPartiallySelected?: boolean;
  onToggleSelectAll?: () => void;
}

const NotificationListHeader = ({ 
  onSort,
  sortConfig,
  showBulkSelect = false,
  isAllSelected = false,
  isPartiallySelected = false,
  onToggleSelectAll
}: NotificationListHeaderProps) => {
  const getSortIcon = (columnKey: string) => {
    if (sortConfig?.key !== columnKey) {
      return <ArrowUpDown className="ml-2 h-4 w-4 opacity-30" />;
    }
    return (
      <ArrowUpDown 
        className={`ml-2 h-4 w-4 transition-transform ${
          sortConfig.direction === 'desc' ? 'rotate-180' : ''
        }`} 
      />
    );
  };

  return (
    <TableHeader>
      <TableRow>
        {showBulkSelect && (
          <TableHead className="w-[50px]">
            <Checkbox
              checked={isAllSelected || isPartiallySelected}
              onCheckedChange={onToggleSelectAll}
              aria-label="Selecteer alle meldingen"
              className={isPartiallySelected ? "data-[state=checked]:bg-blue-500" : ""}
            />
          </TableHead>
        )}
        <TableHead className="w-[80px]">Alert</TableHead>
        <TableHead className="w-[150px] cursor-pointer" onClick={() => onSort('type')}>
          <div className="flex items-center">
            Type
            {getSortIcon('type')}
          </div>
        </TableHead>
        <TableHead>VO Nummer</TableHead>
        <TableHead className="cursor-pointer" onClick={() => onSort('message')}>
          <div className="flex items-center">
            Bericht
            {getSortIcon('message')}
          </div>
        </TableHead>
        <TableHead className="cursor-pointer" onClick={() => onSort('status')}>
          <div className="flex items-center">
            Status
            {getSortIcon('status')}
          </div>
        </TableHead>
        <TableHead className="cursor-pointer" onClick={() => onSort('priority')}>
          <div className="flex items-center">
            Prioriteit
            {getSortIcon('priority')}
          </div>
        </TableHead>
        <TableHead className="cursor-pointer" onClick={() => onSort('created_at')}>
          <div className="flex items-center">
            Aangemaakt
            {getSortIcon('created_at')}
          </div>
        </TableHead>
        <TableHead>Actie</TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default NotificationListHeader;
